import { Outlet } from 'react-router-dom';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Header from './Header.jsx';

const Layout = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
            {/* Header */}
            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    width: "100%",
                    backgroundColor: "white",
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                }}
            >
                <Header />
            </Box>

            {/* Main content area with sidebar + outlet + footer */}
            <Box sx={{ display: "flex", flex: 1, overflow: "auto", flexDirection: "column" }}>
                {/* Main + Footer stacked vertically */}
                <Box
                    sx={{
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        transition: (theme) =>
                            theme.transitions.create(["width", "margin"], {
                                easing: theme.transitions.easing.sharp,
                                duration: theme.transitions.duration.leavingScreen,
                            }),
                    }}
                >
                    {/* Main Outlet */}
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            p: { xs: 1, sm: 2, md: 3 },
                            overflowX: "auto",
                            overflowY: "auto",
                            position: "relative",
                        }}
                    >
                        <Outlet />
                    </Box>

                </Box>
            </Box>
        </Box>

    );
};

export default Layout;
